import { ViewportScroller } from "@angular/common";
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import {
    CoreService,
    DataService,
    DialogService,
    FormNavigationService,
    SpinnerService
} from "dspx-core";
import { AppDataService } from "src/app/services/app-data.service";
import { ErrorService } from "src/app/services/error.service";
import { API_ENDPOINTS } from "../../constants/api-endpoints.constants";
import { ROUTE_CONSTANTS } from "../../constants/route.constants";
import { BaseClassicDetailComponent } from "../base-classic-detail-component/base-classic-detail.component";

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent extends BaseClassicDetailComponent implements OnInit, OnDestroy {

  form!: FormGroup;

  availableForms: { applicationId: string, template: number, formName: string }[] = [];

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected formNavigationService: FormNavigationService,
    private dialogService: DialogService,
    private coreService: CoreService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService,
    private viewportScroller: ViewportScroller,
    private formBuilder: FormBuilder,
  ) {
    super(router, appDataService);
  }

  ngOnInit(): void {
    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
      })
    );

    this.form = this.formBuilder.group({
      formReferenceCode: ['', Validators.required],
    });

    this.appDataService
      .getData(API_ENDPOINTS.formResponse.getAvailableForms, {})
      .subscribe(response => {
        for (const form of response) {
          this.availableForms.push({
            applicationId: form.applicationId,
            template: form.template,
            formName: form.formName,
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  loadBlankForm(applicationId: string, template: number) {
    //this.navigate(['/', ROUTE_CONSTANTS.formResponse.prefix, applicationId, template], true);
    const url = this.router.serializeUrl(this.router.createUrlTree(['/', ROUTE_CONSTANTS.formResponse.prefix, applicationId, template]));
    window.open(url, '_blank');
  }

  retrieveForm() {
    if (this.form.valid) {
      const referenceCode = this.form.get('formReferenceCode')?.value;
      this.navigate(['/', ROUTE_CONSTANTS.formResponse.prefix, referenceCode], true);
    }
  }
}
